import { apiJson } from "./client.js";

/**
 * POST /api/ads/uploads (multipart) — stage an image; the server resizes/normalises it and
 * returns the stored filename (`time()_name`) used as `advertisement_image` (US-D2/G4).
 * Note: no explicit Content-Type — the browser sets the multipart boundary.
 */
export function uploadImage(file: File): Promise<{ tmpRef: string; storedName: string }> {
  const body = new FormData();
  body.append("file", file);
  return apiJson(`/api/ads/uploads`, { method: "POST", body });
}

/** DELETE /api/ads/uploads/:tmpRef — discard an abandoned upload (replace/cancel). */
export function discardUpload(tmpRef: string): Promise<{ ok: true }> {
  return apiJson(`/api/ads/uploads/${encodeURIComponent(tmpRef)}`, { method: "DELETE" });
}
